import * as React from "react";
import { Grid } from "@mui/material";
import MainTheme from "../mainTemplate";
import Title from "../../utilities/title";

const QueueMetricsDetails = () => {
  const metricsData = React.useMemo(() => {
    try {
      const raw = JSON.parse(localStorage.getItem("UIQueueMetricsResponse") || "{}");
      return raw.body ? JSON.parse(raw.body) : {};
    } catch (err) {
      console.error("Error parsing queue metrics data:", err);
      return {};
    }
  }, []);

  const [selectedQueue, setSelectedQueue] = React.useState(null);

  const handleQueueClick = (queueName) => {
    setSelectedQueue(queueName === selectedQueue ? null : queueName);
  };

  return (
    <MainTheme>
      <Title title="Queue Metrics" />
      <div className="organization-details-section">
        <Grid container spacing={2} className="container-section">
          <Grid item xs={12}>
            {Object.keys(metricsData).length === 0 ? (
              <p>No metrics available.</p>
            ) : (
              <div
                style={{
                  display: "flex",
                  gap: "30px",
                  alignItems: "flex-start",
                }}
              >
                {/* Left side - Queue list */}
                <div
                  style={{
                    width: "220px",
                     maxHeight: "320px", // ~7 buttons tall
                     overflowY: "auto",
                     border: "1px solid #ccc",
                     borderRadius: "5px",
                    padding: "10px",
                    // backgroundColor: "#fafafa",
                  }}
                >
                  <h3 style={{ marginTop: 0 }}>Queues</h3>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {Object.keys(metricsData).map((queueName) => (
                      <li key={queueName} style={{ marginBottom: "10px" }}>
                        <div
                          onClick={() => handleQueueClick(queueName)}
                          style={{
                            cursor: "pointer",
                            padding: "10px",
                            backgroundColor:
                              queueName === selectedQueue ? "#e0e0e0" : "#f5f5f5",
                            borderRadius: "5px",
                            border: "1px solid #ccc",
                            textAlign: "center",
                          }}
                        >
                          {queueName}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Right side - Metrics table */}
                <div style={{ flex: 1 }}>
                  {selectedQueue ? (
                    <div
                      style={{
                        padding: "10px",
                        backgroundColor: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        maxHeight: "320px", // ~7 rows
                        overflowY: "auto",
                      }}
                    >
                      <h3 style={{ marginTop: 0 }}>{selectedQueue} Metrics</h3>
                      <table style={{ borderCollapse: "collapse", width: "100%" }}>
                        <thead>
                          <tr>
                            <th
                              style={{
                                border: "1px solid #ccc",
                                padding: "6px",
                                backgroundColor: "#f0f0f0",
                                position: "sticky",
                                top: 0,
                              }}
                            >
                              Metric
                            </th>
                            <th
                              style={{
                                border: "1px solid #ccc",
                                padding: "6px",
                                backgroundColor: "#f0f0f0",
                                position: "sticky",
                                top: 0,
                              }}
                            >
                              Value
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.entries(metricsData[selectedQueue]).map(
                            ([metric, value]) => (
                              <tr key={metric}>
                                <td
                                  style={{
                                    border: "1px solid #ccc",
                                    padding: "6px",
                                  }}
                                >
                                  {metric}
                                </td>
                                <td
                                  style={{
                                    border: "1px solid #ccc",
                                    padding: "6px",
                                  }}
                                >
                                  {value}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p>Select a queue to view its metrics.</p>
                  )}
                </div>
              </div>
            )}
          </Grid>
        </Grid>
      </div>
    </MainTheme>
  );
};

export default QueueMetricsDetails;
